module.exports = __webpack_public_path__ + "static/media/fullLogo.f02cb31f.png";